var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45618 12.0102H0V20.68H6.45618V12.0102Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8294 9.78259H15.3732V20.68H21.8294V9.78259Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1442 6.54985H7.68613V20.68H14.1442V6.54985Z",
    fill: "#434343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6509 3.21402L19.5652 5.0688L21.613 5.36667L20.1329 6.81024L20.4813 8.84959L18.6509 7.88659L16.8205 8.84959L17.169 6.81024L15.6889 5.36667L17.7348 5.06876L18.6509 3.21402Z",
    fill: "#434343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9498 0L11.865 1.85574L13.9128 2.15365L12.4327 3.59813L12.7821 5.63557L10.9508 4.67353L9.11939 5.63557L9.46786 3.59813L7.98776 2.15365L10.0346 1.85574L10.9498 0Z",
    fill: "#434343"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1157 5.37701L4.02997 7.23275L6.07775 7.53158L4.59861 8.97419L4.94707 11.0126L3.1157 10.0505L1.28432 11.0135L1.63374 8.97515L0.153687 7.53249L2.20051 7.23367L3.1157 5.37701Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/Leaderboard.0a406d67b58257a67522fad946f93dea.svg";
export { ForwardRef as ReactComponent };